import { render, staticRenderFns } from "./SellerProductTable.vue?vue&type=template&id=4087ec9f"
import script from "./SellerProductTable.vue?vue&type=script&lang=js"
export * from "./SellerProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports